export { default } from './iframe-bridge';
export type { IIframeBridgeProps } from './iframe-bridge';

export * from './config';
export * from './protocol';
export * from './host';
export * from './route-sync';
